import * as v from 'valibot'

export const OverrideSchema = v.object({
	override_target_date: v.pipe(v.string(), v.minLength(1, 'Target date is required')),
	override_starts_at: v.pipe(v.string(), v.minLength(1, 'New start time is required')),
})

export type OverrideForm = v.InferInput<typeof OverrideSchema>
